import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { motion, AnimatePresence } from "framer-motion";

const navLinks = [
  { label: "Product", path: "/product" },
  { label: "Applications", path: "/applications" },
  { label: "Technology", path: "/technology" },
  { label: "Why Dust Matters", path: "/why-dust-matters" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <nav
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0a0b0d]/80 border-b border-[#2d3239]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="navbar-logo">
          <img
            src="https://customer-assets.emergentagent.com/job_dustsentinel-lx/artifacts/aggpk6vn_ChatGPT%20Image%20May%206%2C%202026%2C%2011_36_09%20AM%20%283%29.png"
            alt="DustSentinel"
            className="h-8 w-8 object-contain"
          />
          <span className="font-mono text-sm tracking-[0.15em] uppercase text-[#f2f4f8] hidden sm:inline">
            DustSentinel
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={`font-mono text-xs tracking-wider uppercase transition-colors ${
                location.pathname === link.path
                  ? "text-[#4b7399]"
                  : "text-[#8c9eb3] hover:text-[#f2f4f8]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#f2f4f8]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[#0a0b0d] border-b border-[#2d3239]"
          >
            <div className="px-6 py-4 flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setOpen(false)}
                  className={`font-mono text-xs tracking-wider uppercase ${
                    location.pathname === link.path
                      ? "text-[#4b7399]"
                      : "text-[#8c9eb3]"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
